module.exports = __webpack_public_path__ + "img/demerol.71b057ea.png";